<template>
  <div id="voteEdit">
    <div
      v-if="nowPage === 1"
      class="main"
    >
      <div class="title_bar">
        <div class="left">
          <div class="title">
            發起投票
          </div>
        </div>
        <div class="right">
          <span class="tips">*為必填</span>
        </div>
      </div>
      <div class="secondTitleBlock">
        <div class="secondTitle">
          主題說明
        </div>
        <div class="secondTitleNote">
          設定要發起的投票主題、時間及說明等
        </div>
      </div>
      <div class="blockWrap">
        <el-form
          ref="newsData"
          class="list"
          :model="newsData"
          status-icon
          label-position="left"
          :rules="rule"
        >
          <el-form-item
            label="標題"
            prop="Title"
          >
            <el-input
              v-model="newsData.Title"
              placeholder="請輸入標題"
              maxlength="30"
              size="medium"
            />
            <el-checkbox-group
              v-model="newsData.Tag"
              class="tagBlock"
            >
              <el-checkbox label="重要事務" />
              <el-checkbox label="開放留言" />
            </el-checkbox-group>
            <span>限30個字元</span>
          </el-form-item>
          <el-form-item
            label="內容說明"
            prop="Detail"
          >
            <el-input
              v-model="newsData.Detail"
              type="textarea"
              maxlength="200"
            />
            <span>限200個字元</span>
          </el-form-item>
          <el-form-item>
            <span slot="label" class="redStar">投票期間</span>
            <el-radio-group
              v-model="newsData.VoteNow"
              @change="changeVoteNow"
            >
              <el-radio :label="false">
                自訂時間
              </el-radio>
              <el-radio :label="true">
                現在時間
              </el-radio>
            </el-radio-group>
            <div class="Interval">
              <el-form-item
                ref="startTime"
                class="el-form-item-date"
                prop="Start"
              >
                <el-date-picker
                  v-model="newsData.Start"
                  format="yyyy/MM/dd HH:mm"
                  size="small"
                  type="datetime"
                  :disabled="newsData.VoteNow"
                  placeholder="選擇起日"
                  :picker-options="datePickerOptions"
                  :clearable="false"
                />
              </el-form-item>
              <el-form-item
                ref="dueTime"
                class="el-form-item-date"
                prop="Due"
              >
                <el-date-picker
                  v-model="newsData.Due"
                  format="yyyy/MM/dd HH:mm"
                  size="small"
                  type="datetime"
                  placeholder="選擇訖日"
                  :picker-options="datePickerOptions"
                  :clearable="false"
                />
              </el-form-item>
            </div>
            <span v-if="newsData.VoteNow">按下發起後隨即開始投票！</span>
          </el-form-item>
          <el-form-item
            label="投票者限制"
            prop="Type"
          >
            <el-select
              v-model="newsData.Type"
              placeholder="請選擇"
              size="small"
            >
              <el-option
                v-for="item in TypeList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="附加檔案"
            prop="Files"
          >
            <file
              type="file"
              name="file"
              :filearray="newsData.Files"
              :quantity="3"
              @on-fileArray-change="FilesChange"
            />
          </el-form-item>
          <el-form-item
            label="附加圖片"
            prop="ImageFiles"
          >
            <file
              type="img"
              name="img"
              :filearray="newsData.ImageFiles"
              :quantity="3"
              @on-fileArray-change="ImageFilesChange"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="secondTitleBlock">
        <div class="secondTitle">
          建立問題及選項
        </div>
        <div class="secondTitleNote">
          設定要新增的投票問題，說明及選項
        </div>
      </div>
      <div
        v-for="(item, index) in questionData"
        :key="index"
        class="questionBlock"
      >
        <div class="question">
          <el-form
            class="list questionForm"
            status-icon
            label-position="left"
            :model="item"
          >
            <el-form-item
              v-if="!item.isShowEdit"
              label="問題"
              prop="Title"
            >
              <el-button
                type="primary"
                plain
                @click="item.isShowEdit = true"
              >
                新增問題之標題說明
              </el-button>
            </el-form-item>
            <el-form-item
              v-if="item.isShowEdit"
              label="題目"
              prop="Title"
            >
              <el-input
                v-model="item.Title"
                placeholder="請輸入題目"
                maxlength="30"
                size="medium"
              />
              <span>限30個字元</span>
            </el-form-item>
            <el-form-item
              v-if="item.isShowEdit"
              label="題目說明"
              prop="Description"
            >
              <el-input
                v-model="item.Description"
                type="textarea"
                maxlength="200"
              />
              <span>限200個字元</span>
            </el-form-item>
            <el-form-item
              label="選項類型"
              prop="Type"
            >
              <el-select
                v-model="item.Type"
                placeholder="請選擇"
                size="small"
              >
                <el-option
                  v-for="type in OptionTypeList"
                  :key="type.Id"
                  :label="type.Name"
                  :value="type.Id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div>
            <el-button @click="delQuestion(index)">
              刪除問題
            </el-button>
          </div>
        </div>
        <div class="optionBlock">
          <el-table :data="item.optionData">
            <el-table-column
              prop="Id"
              width="90"
            >
              <template slot-scope="scope">
                <span v-if="scope.$index + 1 <= 2" class="required-field">*</span>
                <span>{{ filterOptionIndex(scope.$index) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="Image"
              label="附加圖片"
              width="165"
            >
              <template slot-scope="scope">
                <div class="file-wrap">
                  <div
                    v-if="scope.row.Image[0]"
                    class="file"
                  >
                    <div
                      class="bg-img"
                      :style="`background-image: url('${scope.row.Image[0].BS64 ? scope.row.Image[0].BS64 : scope.row.Image[0].uploadUrl}')`"
                      @click="openLightbox(scope.row.Image[0].BS64 ? scope.row.Image[0].BS64 : scope.row.Image[0].uploadUrl)"
                    />
                    <div class="optionBtn-wrap">
                      <div
                        class="btn"
                        @click="addOptionFile(index, scope.$index)"
                      >
                        更換
                      </div>
                      <div
                        class="btn"
                        @click="deleteOptionFile(index, scope.$index)"
                      >
                        刪除
                      </div>
                    </div>
                  </div>
                  <div
                    v-show="!scope.row.Image[0]"
                    class="file file-plus"
                    @click="addOptionFile(index, scope.$index)"
                  >
                    <i
                      class="icon-plus"
                      aria-hidden="true"
                    />
                    <span>新增圖片</span>
                    <input
                      :id="`question${index}Option${scope.$index}`"
                      type="file"
                      style="display: none"
                      @change="AddFileChangeEve"
                    >
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="Content"
            >
              <template #header>
                <span class="redStar">選項內容</span>
              </template>
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.Content"
                  class="optionInput"
                  type="textarea"
                  placeholder="輸入選項"
                  maxlength="15"
                  @input="addOption(index)"
                  @blur="checkOptionValid(index, scope.$index, $event)"
                />
                <span>限15個字元</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="Note"
              label="選項備註"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.Note"
                  type="textarea"
                  placeholder="當選擇此選項後要輸入的內容"
                  maxlength="15"
                />
                <span>限15個字元</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="110"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  @click="delOption(index, scope)"
                >
                  刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-button
        class="addQuestionBtn"
        @click="addQuestion"
      >
        <i
          class="icon-plus"
          aria-hidden="true"
        />新增問題
      </el-button>
      <div class="bottomControl">
        <el-button
          round
          @click="$router.push({name:'voteList'})"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          round
          @click="goPreview"
        >
          下一步
        </el-button>
      </div>
    </div>

    <div
      v-if="nowPage === 2"
      class="main preview"
    >
      <div class="title_bar">
        <div class="left">
          <div class="title">
            預覽投票內容
          </div>
        </div>
      </div>
      <div class="preview-content">
        <div class="title-bar">
          <div class="title-wrap">
            <span class="vote-title">{{ newsData.Title }}</span>
            <span
              v-if="newsData.Tag.indexOf('重要事務') !== -1"
              class="tag important"
            >重要事務</span>
            <span
              v-if="newsData.Tag.indexOf('開放留言') !== -1"
              class="tag canComment"
            >開放留言</span>
          </div>
          <el-button @click="goEdit">
            編輯
          </el-button>
        </div>
        <div class="content-bar">
          <div class="vote-content">
            {{ newsData.Detail }}
          </div>
          <div class="vote-time">
            投票期間：{{ filterDate(newsData.Start) }} 至 {{ filterDate(newsData.Due) }}
          </div>
          <div class="vote-type">
            投票者限制：{{ filterVoterType(newsData.Type) }}
          </div>
          <div class="secondTitleBlock">
            <div class="secondTitle">
              附加文件
            </div>
            <ul class="fileList">
              <li
                v-for="(item, index) in newsData.Files"
                :key="index"
                class="fileList-item"
              >
                文件{{ index + 1 }}
              </li>
            </ul>
          </div>
          <div class="secondTitleBlock">
            <div class="secondTitle">
              附加圖片
            </div>
            <img
              v-for="(item, index) in newsData.ImageFiles"
              :key="index"
              :src="item.BS64 ? item.BS64 : item.uploadUrl"
              alt=""
              @click="previewLightboxIndex = index"
            >
            <CoolLightBox
              :items="previewLightboxItem"
              :index="previewLightboxIndex"
              :slideshow="false"
              @close="previewLightboxIndex = null"
            />
          </div>
        </div>
      </div>
      <div class="question-content">
        <div
          v-for="(item, index) in questionData"
          :key="index"
          class="question"
        >
          <div class="question-title-wrap">
            <span class="question-title">問題{{ index + 1 }} {{ item.Title }}</span>
            <span class="tag">{{ filterQuestionType(item.Type) }}</span>
          </div>
          <div class="question-content">
            {{ item.Description }}
          </div>
          <div class="option-wrap">
            <div
              v-for="(option, optionIndex) in item.optionData"
              :key="optionIndex"
              class="option"
            >
              <img
                v-if="option.Image[0]"
                :src="option.Image[0].BS64 ? option.Image[0].BS64 : option.Image[0].uploadUrl"
                alt=""
                @click="openLightbox(option.Image[0].BS64 ? option.Image[0].BS64 : option.Image[0].uploadUrl)"
              >
              <div class="option-text">
                <div class="option-content">
                  {{ option.Content }}
                </div>
                <div
                  v-if="option.Note"
                  class="option-note"
                >
                  選擇此選項需填寫: {{ option.Note }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomControl">
        <el-button
          round
          @click="sendData('save')"
        >
          儲存
        </el-button>
        <el-button
          type="primary"
          round
          @click="sendData('send')"
        >
          發送
        </el-button>
      </div>
    </div>
    <CoolLightBox
      :items="lightbox.item"
      :index="lightbox.index"
      :slideshow="false"
      @close="lightbox.index = null"
    />
  </div>
</template>
<script>
import file from '@/components/File'
import { scrollToElement } from '@/js/utils'
export default {
  components: {
    file
  },
  data () {
    const vm = this
    // 比較起迄日時紅框需同步啟動、互相驗證，要此變數避免無限迴圈
    let isValidating = false
    const validateStart = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('Form.NoStartTime')))
        return
      }

      if (!this.newsData.Due) {
        callback()
        return
      }

      if (!isValidating) {
        isValidating = true
        this.$refs.newsData.validateField('Due', () => {
          isValidating = false
        })
      }

      if (dayjs(value).isSame(this.newsData.Due)) {
        callback(new Error(this.$t('Form.sameStartAndEndTime')))
      } else if (dayjs(value).isAfter(this.newsData.Due)) {
        callback(new Error(this.$t('Form.StartTimeGreaterThanEndTime')))
      } else {
        callback()
      }
    }

    const validateDue = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('Form.NoDueTime')))
        return
      }

      if (!this.newsData.Start) {
        callback()
        return
      }

      if (!isValidating) {
        isValidating = true
        this.$refs.newsData.validateField('Start', () => {
          isValidating = false
        })
      }

      if (dayjs(value).isSame(this.newsData.Start) || dayjs(value).isBefore(this.newsData.Start)) {
        // 錯誤訊息一律顯示在起日，迄日只要有紅框
        // 但若給空字串，ELement會自動顯示'Error'，因此這邊給一個空格
        callback(new Error(' '))
      } else {
        callback()
      }
    }
    return {
      nowPage: 1,
      newsData: {
        Id: 0,
        Title: '',
        Detail: '',
        Start: '',
        Due: '',
        VoteNow: false,
        Type: 0,
        Files: [],
        ImageFiles: [],
        Tag: []
      },
      TypeList: [
        {
          Id: 0,
          Name: '一戶一票'
        },
        {
          Id: 1,
          Name: '一人一票'
        }
      ],
      OptionTypeList: [
        {
          Id: 0,
          Name: '單選'
        },
        {
          Id: 1,
          Name: '複選'
        }
      ],
      rule: {
        Title: [
          { required: true, message: '標題不可為空', trigger: 'blur' }
        ],
        Type: [
          { required: true, message: '選項內容不可為空', trigger: 'blur' }
        ],
        Start: [
          { required: true, validator: validateStart, trigger: 'blur' }
        ],
        Due: [
          { required: true, validator: validateDue, trigger: 'blur' }
        ]
      },
      datePickerOptions: {
        disabledDate (time) {
          const today = vm.$formatDate(new Date())
          return time.getTime() < new Date(today).getTime()
        }
      },
      questionData: [
        {
          Id: 0,
          Title: '',
          Description: '',
          Type: 0,
          isShowEdit: false,
          optionData: [
            {
              Id: 0,
              Image: [],
              Content: '',
              Note: ''
            },
            {
              Id: 0,
              Image: [],
              Content: '',
              Note: ''
            }
          ]
        }
      ],
      lightbox: {
        item: [],
        index: null
      },
      previewLightboxIndex: null
    }
  },
  computed: {
    previewLightboxItem () {
      const images = this.newsData.ImageFiles.map(item => {
        return item.uploadUrl ? item.uploadUrl : item.BS64
      })
      return images
    }
  },
  watch: {
  },
  mounted () {
    this.getVote()
  },
  methods: {
    // 取得投票內容
    getVote () {
      if (this.$route.params.id) {
        apiVote.Vote.GetVote({ VotingId: this.$route.params.id }).then(res => {
          console.log(res)
          const tag = []
          if (res.data.Data.IsImportant) {
            tag.push('重要事務')
          }
          if (res.data.Data.CanComment) {
            tag.push('開放留言')
          }
          const allFiles = JSON.parse(res.data.Data.Files.replace(/name:/g, '"name":').replace(/type:/g, '"type":'))
          const files = []
          allFiles.forEach(item => {
            if (item.type === 'file') {
              files.push({
                file: '',
                uploadUrl: item.name
              })
            }
          })
          const imageFiles = []
          allFiles.forEach(item => {
            if (item.type === 'image') {
              imageFiles.push({
                type: 'img',
                BS64: '',
                file: '',
                uploadUrl: item.name
              })
            }
          })
          this.newsData = {
            Id: res.data.Data.Id,
            Title: res.data.Data.Title,
            Detail: res.data.Data.Content,
            Start: new Date(res.data.Data.StartTime.replace('T', ' ').replace('Z', '')),
            Due: new Date(res.data.Data.DueTime.replace('T', ' ').replace('Z', '')),
            VoteNow: false,
            Type: res.data.Data.VoterType,
            Files: files,
            ImageFiles: imageFiles,
            Tag: tag
          }
          const questions = []
          res.data.Data.Questions.forEach(item => {
            const options = []
            item.Candidates.forEach(optionItem => {
              options.push({
                Id: optionItem.Id,
                Image: optionItem.Image
                  ? [{
                    BS64: '',
                    file: '',
                    uploadUrl: optionItem.Image
                  }]
                  : [],
                Content: optionItem.Content,
                Note: optionItem.Note
              })
            })
            questions.push({
              Id: item.Id,
              Title: item.Topic,
              Description: item.Description,
              Type: item.Type,
              isShowEdit: item.Topic || item.Description,
              optionData: options
            })
          })
          this.questionData = questions
        }).catch(err => {
          console.log(err)
        })
      }
    },

    // 檔案的components回釣函式
    FilesChange (val) {
      this.newsData.Files = val
    },
    // 檔案的components回釣函式
    ImageFilesChange (val) {
      this.newsData.ImageFiles = val
    },
    filterVoterType (type) {
      switch (type) {
      case 0:
        return '一戶一票'
      case 1:
        return '一人一票'
      }
    },
    filterQuestionType (type) {
      switch (type) {
      case 0:
        return '單選題'
      case 1:
        return '多選題'
      }
    },
    filterDate (date) {
      if (date) {
        const YYYY = date.getFullYear()
        const MM = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
        const DD = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
        const HH = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
        const mm = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
        return `${YYYY}-${MM}-${DD} ${HH}:${mm}`
      }
    },
    uploadFile (file, callback) {
      const formData = new FormData()
      formData.append('File', file)
      apiVote.Vote.UploadFile(formData).then(res => {
        console.log(res)
        callback(res.data.Data)
      }).catch(err => {
        console.log(err)
      })
    },
    // 送出按鈕
    sendData (mode) {
      const vm = this
      let isCheck
      switch (mode) {
      case 'save':
        isCheck = 0
        break
      case 'send':
        isCheck = 1
        break
      }

      // 上傳附加檔案
      const files = []
      function uploadFile () {
        return new Promise(resolve => {
          if (vm.newsData.Files.length) {
            vm.newsData.Files.forEach(item => {
              if (!item.uploadUrl) {
                vm.uploadFile(item.file, res => {
                  item.uploadUrl = res
                  files.push({
                    type: 'file',
                    name: item.uploadUrl.split('/')[item.uploadUrl.split('/').length - 1]
                  })
                  if (files.length === vm.newsData.Files.length) {
                    resolve()
                  }
                })
              } else {
                files.push({
                  type: 'file',
                  name: item.uploadUrl.split('/')[item.uploadUrl.split('/').length - 1]
                })
                if (files.length === vm.newsData.Files.length) {
                  resolve()
                }
              }
            })
          } else {
            resolve()
          }
        })
      }

      // 上傳附加圖片
      const imageFiles = []
      function uploadImage () {
        return new Promise(resolve => {
          if (vm.newsData.ImageFiles.length) {
            vm.newsData.ImageFiles.forEach(item => {
              if (!item.uploadUrl) {
                vm.uploadFile(item.file, res => {
                  item.uploadUrl = res
                  imageFiles.push({
                    type: 'image',
                    name: item.uploadUrl.split('/')[item.uploadUrl.split('/').length - 1]
                  })
                  if (imageFiles.length === vm.newsData.ImageFiles.length) {
                    resolve()
                  }
                })
              } else {
                imageFiles.push({
                  type: 'image',
                  name: item.uploadUrl.split('/')[item.uploadUrl.split('/').length - 1]
                })
                if (imageFiles.length === vm.newsData.ImageFiles.length) {
                  resolve()
                }
              }
            })
          } else {
            resolve()
          }
        })
      }

      const question = []
      vm.questionData.forEach(item => {
        const option = []
        item.optionData.forEach(optionItem => {
          option.push({
            Id: optionItem.Id,
            Image: optionItem.Image[0] ? optionItem.Image[0].uploadUrl.split('/')[optionItem.Image[0].uploadUrl.split('/').length - 1] : null,
            Content: optionItem.Content,
            Note: optionItem.Note
          })
        })
        question.push({
          Id: item.Id,
          Topic: item.Title,
          Description: item.Description,
          Type: item.Type,
          Candidates: option
        })
      })

      uploadFile()
        .then(() => {
          return uploadImage()
        })
        .then(() => {
          const params = {
            Id: vm.newsData.Id,
            Title: vm.newsData.Title,
            Content: vm.newsData.Detail,
            StartTime: `${vm.filterDate(vm.newsData.Start)}:00`,
            DueTime: `${vm.filterDate(vm.newsData.Due)}:00`,
            VoterType: vm.newsData.Type,
            View: '',
            Files: JSON.stringify([...files, ...imageFiles]),
            IsCheck: isCheck,
            IsImportant: vm.newsData.Tag.indexOf('重要事務') !== -1,
            CanComment: vm.newsData.Tag.indexOf('開放留言') !== -1,
            Questions: question
          }
          console.log(params)
          if (mode === 'save') {
            vm.$alert('您的投票項目已儲存! 在發起投票前都可以編輯喔!', '', {
              confirmButtonText: '確定',
              callback: action => {
                if (params.Id === 0) {
                  apiVote.Vote.PostVote(params).then(res => {
                    vm.$store.commit('ifVoteEdit', true)
                    vm.$router.push({ name: 'voteList' })
                    vm.$message({
                      type: 'success',
                      message: '投票新增成功'
                    })
                  }).catch(err => {
                    console.log(err)
                    vm.$message({
                      type: 'error',
                      message: '投票新增失敗'
                    })
                  })
                } else {
                  apiVote.Vote.PutVote(params).then(res => {
                    vm.$store.commit('ifVoteEdit', true)
                    vm.$router.push({ name: 'voteList' })
                    vm.$message({
                      type: 'success',
                      message: '投票更新成功'
                    })
                  }).catch(err => {
                    console.log(err)
                    vm.$message({
                      type: 'error',
                      message: '投票更新失敗'
                    })
                  })
                }
              }
            })
          } else {
            vm.$confirm('提醒您，發送後無法再進行修改!', '發送提醒', {
              confirmButtonText: '發送',
              callback: action => {
                if (params.Id === 0) {
                  apiVote.Vote.PostVote(params).then(res => {
                    vm.$store.commit('ifVoteEdit', true)
                    vm.$router.push({ name: 'voteList' })
                    vm.$message({
                      type: 'success',
                      message: '投票新增成功'
                    })
                  }).catch(err => {
                    console.log(err)
                    vm.$message({
                      type: 'error',
                      message: '投票新增失敗'
                    })
                  })
                } else {
                  apiVote.Vote.PutVote(params).then(res => {
                    vm.$store.commit('ifVoteEdit', true)
                    vm.$router.push({ name: 'voteList' })
                    vm.$message({
                      type: 'success',
                      message: '投票更新成功'
                    })
                  }).catch(err => {
                    console.log(err)
                    vm.$message({
                      type: 'error',
                      message: '投票更新失敗'
                    })
                  })
                }
              }
            })
          }
        })
    },

    changeVoteNow () {
      if (this.newsData.VoteNow) {
        this.newsData.Start = new Date()
        // 如果從自訂時間切換到現在時間後格式不符合，則自動重置
        if (dayjs(this.newsData.Start).isAfter(this.newsData.Due)) {
          this.newsData.Due = ''
        }
      }

      // 切換時都把表單狀態重整一下清除一下，比較不容易壞
      this.$refs.newsData.clearValidate(['Start', 'Due'])
    },
    addQuestion () {
      this.questionData.push(
        {
          Id: 0,
          Title: '',
          Description: '',
          Type: 0,
          isShowEdit: false,
          optionData: [
            {
              Id: 0,
              Image: '',
              Content: '',
              Note: ''
            },
            {
              Id: 0,
              Image: '',
              Content: '',
              Note: ''
            }
          ]
        }
      )
    },
    delQuestion (index) {
      this.$alert('是否刪除此項問題？', '', {
        confirmButtonText: '確定',
        callback: action => {
          if (this.questionData.length > 1) {
            this.questionData.splice(index, 1)
          } else {
            this.$alert('每個投票最少要有一個題目!', '', {
              confirmButtonText: '確定',
              callback: action => {}
            })
          }
        }
      })
    },
    addOption (index) {
      let nonEmptySum = 0
      this.questionData[index].optionData.forEach(item => {
        if (item.Content) {
          nonEmptySum++
        }
      })
      if (nonEmptySum === this.questionData[index].optionData.length) {
        this.questionData[index].optionData.push(
          {
            Id: 0,
            Image: '',
            Content: '',
            Note: ''
          }
        )
      }
    },
    delOption (index, scope) {
      if (this.questionData[index].optionData.length > 2) {
        this.questionData[index].optionData.splice(scope.$index, 1)
      } else {
        this.$alert('每個題目最少要有兩個選項!', '', {
          confirmButtonText: '確定',
          callback: action => {}
        })
      }
    },
    filterOptionIndex (index) {
      return `選項${index + 1}`
    },

    // option 圖片上傳
    addOptionFile (questionIndex, optionIndex) {
      document.getElementById(`question${questionIndex}Option${optionIndex}`).click()
    },
    deleteOptionFile (questionIndex, optionIndex) {
      this.questionData[questionIndex].optionData[optionIndex].Image = []
    },
    AddFileChangeEve (event) {
      const acceptFileType = ['jpg', 'jpeg', 'png', 'gif']
      const acceptFileSize = 4194304
      const fileType = event.target.files[0].name.split('.')[event.target.files[0].name.split('.').length - 1].toLowerCase()
      const filesize = event.target.files[0].size
      const questionIndex = event.target.id.split('Option')[0].replace('question', '')
      const optionIndex = event.target.id.split('Option')[1]
      let ErrMsg
      if (acceptFileType.indexOf(fileType) === -1) {
        // 判斷檔案類型
        ErrMsg = '圖片只允許 jpg、jpeg、png、gif'
        this.$alert(ErrMsg, '錯誤', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {
          }
        })
        event.target.value = '' // 清空input file
        return false
      } else if (filesize > acceptFileSize) {
        // 判斷檔案大小
        ErrMsg = '圖片限制為 4MB 以下'
        this.$alert(ErrMsg, '錯誤', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {
          }
        })
        event.target.value = '' // 清空input file
        return false
      } else if (filesize === 0) {
        // 判斷檔案大小不可為0
        ErrMsg = '圖片不得為0KB'
        this.$alert(ErrMsg, '錯誤', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {
          }
        })
        event.target.value = '' // 清空input file
        return false
      }

      function GetBS64 (file, callback) {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          callback(this.result)
        }
      }
      GetBS64(event.target.files[0], res => {
        this.questionData[questionIndex].optionData[optionIndex].Image = [{
          BS64: res,
          file: event.target.files[0]
        }]
      })
      this.uploadFile(event.target.files[0], (res) => {
        this.questionData[questionIndex].optionData[optionIndex].Image[0].uploadUrl = res
      })
    },
    checkOptionValid (questionIndex, optionIndex, e) {
      const isEssentialOption = optionIndex < 2
      const isLastOption = optionIndex === this.questionData[questionIndex].optionData.length - 1
      const isNote = !!this.questionData[questionIndex].optionData[optionIndex].Note
      // 有內容，一定合法
      if (e.target.value) {
        e.target.classList.remove('invalid')
        return
      }

      // 不是前兩個、是最後一個選項、沒有備註，才允許不填
      if (!isEssentialOption && isLastOption && !isNote) {
        e.target.classList.remove('invalid')
        return
      }

      // 剩下來一定不合法
      e.target.classList.add('invalid')
    },
    goPreview () {
      document.querySelectorAll('.optionInput .el-textarea__inner').forEach(item => {
        item.focus({ preventScroll: true })
        item.blur()
      })
      let isOptionValid = false
      const invalidOption = document.querySelectorAll('.optionInput .el-textarea__inner.invalid')
      if (invalidOption.length === 0) {
        isOptionValid = true
      }

      this.$refs.newsData.validate((valid, validateObj) => {
        const startMsg = validateObj.Start?.[0]?.message
        // 有多種錯誤訊息，但若是「不可為空」，則與其他欄位整合只顯示「*必填」
        if (!valid) {
          if (validateObj.Title && startMsg && startMsg !== this.$t('Form.NoStartTime')) {
            this.$message.error({
              message: `${this.$t('Form.requiredFields')} <br><br> ${startMsg}`,
              dangerouslyUseHTMLString: true
            })
          } else if (startMsg && startMsg !== this.$t('Form.NoStartTime')) {
            this.$message.error(startMsg)
          } else {
            this.$message.error(this.$t('Form.requiredFields'))
          }

          this.$nextTick(() => {
            scrollToElement('.is-error')
          })
          return
        }

        if (!isOptionValid) {
          this.$message.error(this.$t('Form.requiredFields'))
          this.$nextTick(() => {
            scrollToElement('.optionInput .el-textarea__inner.invalid')
          })
          return
        }

        // 已通過，進入下一頁面預覽
        this.nowPage = 2
        window.scrollTo({ top: 0 })
        this.questionData.forEach((item, index) => { // 去除方便使用者填寫多的一個選項
          if (item.optionData.length > 2 && item.optionData[item.optionData.length - 1].Content === '') {
            this.questionData[index].optionData.splice(item.optionData.length - 1, 1)
          }
        })
      })
    },
    goEdit () {
      // 在預覽時，會把空選項切掉
      // 但是在新增/編輯頁面，我們期望有空選項讓他好輸入
      // 因此若返回編輯，則需把空選項加回來
      this.questionData.forEach((item, index) => this.addOption(index))
      this.nowPage = 1
      window.scrollTo({ top: 0 })
    },
    openLightbox (image) {
      this.lightbox.index = 0
      this.lightbox.item = [image]
    }
  }
}
</script>
<style lang="sass" scoped>
#voteEdit
  padding: 50px 0
  ::v-deep .el-dialog
    +basicDialog
    p
      line-height: 25px
  .main
    min-width: 1140px
    max-width: 1140px
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      padding-bottom: 20px
      border-bottom: solid 1px $borderDark1
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        color: $mainFontColor
        text-align: left
      .tips
        color: #f00
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
    .redStar
      // @mixin: redStar 在這裡位置偏高，先不使用
      &::before
        content: '*'
        color: $dangerColor
        margin-right: 4px
  ::v-deep .el-form.list
    +basicFormInsert
    &.questionForm
      width: 60%
    .el-form-item
      .Interval
        display: flex
        .el-form-item:first-child
          margin-right: 10px
      &.half
        width: 50%
      &__content
        flex: 1
        // max-width: 400px
        .file-wrap
          flex-wrap: wrap
        .el-select,.el-date-editor
          width: 100%
      .tagBlock
        margin-top: 10px
    .el-form-item-date
      margin-bottom: 5px
  .secondTitleBlock
    padding: 20px 0 30px 0
    .secondTitle
      font-size: 25px
      font-weight: bold
      line-height: 1.5
    .secondTitleNote
      color: #aaaaaa
  .blockWrap
    text-align: left
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    margin-bottom: 30px
    padding: 0 240px 0 240px
    box-sizing: border-box
  ::v-deep .questionBlock
    margin-bottom: 50px
    .question
      display: flex
      justify-content: space-between
      margin-bottom: 10px
    .optionBlock
      td.el-table_1_column_1
        font-size: 20px
        font-weight: bold
      textarea
        height: 128px
        &.invalid
          border-color: $dangerColor
      .addImageBtn
        width: 150px
        height: 155px
        border: solid 1px $borderDark1
        border-radius: 4px
        display: flex
        justify-content: center
        align-items: center
        transition: 0.4s
        cursor: pointer
        &:hover
          box-shadow: 0 0 8px rgba(120, 120, 120, 0.5)
      .required-field
          color: $dangerColor
          margin-right: 4px
  .addQuestionBtn
    margin-bottom: 20px
  .bottomControl
    text-align: center
    border-top: solid 1px $borderDark1
    padding: 30px 0 0
  ::v-deep .el-table
    +basicTable
.file-wrap
  display: flex
  .file
    width: 150px
    height: 150px
    border: 1px solid $borderDark1
    color: #666
    border-radius: 8px
    cursor: pointer
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    position: relative
    overflow: hidden
    &.error
      border: 1px solid #c44536
    &.success
      border: 1px solid #a5be00
    &:hover
      color: $mainFontColor
      border: 1px solid #aaa
      box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
      transition: .4s
      .optionBtn-wrap
        bottom: 0
    i
      font-size: 60px
    span
      font-size: 17px
      font-weight: 700
      width: 100%
      white-space: nowrap
      text-overflow: ellipsis
      overflow: hidden
      text-align: center
      margin-top: 10px
    .bg-img
      height: 100%
      width: 100%
      background-position: center
      background-size: cover
    .optionBtn-wrap
      display: flex
      position: absolute
      bottom: -30px
      width: 100%
      transition: .4s
      .btn
        width: 50%
        font-size: 17px
        font-weight: bold
        line-height: 30px
        text-align: center
        cursor: pointer
        background: -webkit-gradient( linear, left top, left bottom, color-stop(8%, #ededed), color-stop(97%, #dfdfdf) )
        background-color: #ededed
        &:first-child
          border-right: 1px solid #999
        &:hover
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#dfdfdf', endColorstr='#ededed')
          background: -webkit-gradient( linear, left top, left bottom, color-stop(8%, #dfdfdf), color-stop(97%, #ededed))
          background-color: #dfdfdf
  .file-plus
    border: 1px solid $mainColor
    color: $mainColor
    &:hover
      color: $mainColor
      border: 1px solid $mainColor
      box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
      transition: .4s
.preview
  .title-bar
    display: flex
    justify-content: space-between
    align-items: center
    margin-top: 30px
    .title-wrap
      display: flex
      align-items: center
      .vote-title
        color: $mainColor
        font-size: 30px
        margin-right: 10px
      .tag
        margin-right: 10px
        color: #fff
        padding: 4px 12px
        &.important
          background-color: $warnColor
        &.canComment
          background-color: $infoColor
  .content-bar
    padding: 10px 15px
    font-size: 17px
    .vote-content
      margin-bottom: 10px
      word-break: break-word
    .vote-time, .vote-type
      font-weight: bold
      line-height: 1.5
    .secondTitleBlock
      img
        max-width: 220px
        margin-right: 30px
        border: 1px solid $mainColor
        &:hover
          color: $mainFontColor
          border: 1px solid #aaa
          box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
          transition: .4s
          cursor: pointer
      .fileList
        padding-left: 40px
        .fileList-item
          list-style-type: disc
          line-height: 1.5
  .question-content
    .question
      padding: 30px 35px
      border: 1px solid #d3d3d3
      .question-title-wrap
        display: flex
        align-items: center
        margin-bottom: 10px
        .question-title
          font-size: 30px
          font-weight: bold
        .tag
          color: $mainColor
          background-color: #eee
          padding: 3px 5px
          font-weight: bold
          margin-left: 15px
      .question-content
        font-size: 17px
        margin-bottom: 30px
      .option
        padding: 20px
        display: flex
        border: 1px solid #d3d3d3
        img
          max-width: 177px
          border: 1px solid $mainColor
          &:hover
            color: $mainFontColor
            border: 1px solid #aaa
            box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
            transition: .4s
            cursor: pointer
        .option-text
          margin: 0 10px
          .option-content
            font-size: 24px
            font-weight: bold
          .option-note
            font-size: 17px
            margin-top: 15px
</style>
